"use client";

import { useEffect, useRef, useState } from "react";

// Cuenta regresiva hasta `target` (ISO): segundos restantes y texto
// ("hh:mm:ss", o "mm:ss" con short). Llama a onDone una vez al llegar a cero.
export function useCountdown(
  target: string,
  onDone: () => void,
  { short = false }: { short?: boolean } = {},
): { secondsLeft: number; text: string } {
  const [now, setNow] = useState(() => Date.now());
  const done = useRef(false);
  const end = Date.parse(target);
  useEffect(() => {
    done.current = false;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);
  useEffect(() => {
    if (now >= end && !done.current) {
      done.current = true;
      onDone();
    }
  }, [now, end, onDone]);
  const left = Math.max(0, Math.floor((end - now) / 1000));
  const pad = (n: number) => String(n).padStart(2, "0");
  const mmss = `${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
  return {
    secondsLeft: left,
    text: short && left < 3600 ? mmss : `${pad(Math.floor(left / 3600))}:${mmss}`,
  };
}
